import Helper from '@ember/component/helper';
import { get } from '@ember/object';
import { service } from '@ember/service';

export default Helper.extend({
  settings: service(),

  // params
  // 0 - orgSettingName
  // 1 - value
  compute(params) {
    let [orgSettingName, val] = params;
    return get(this, `settings.orgSettings.${orgSettingName}`) === val;
  },
});
